import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';

export const getReleaseGroupComponentCountQueryKey = (
  releaseGroupId: number,
  releaseId: number,
): QueryKey => ['binary', 'release-group', releaseGroupId, 'release', releaseId, 'components', 'count'];

function getReleaseGroupComponentCount(releaseGroupId: number, releaseId: number) {
  return get<{ count: number }>(`/api/binary/release-group/${releaseGroupId}/release/${releaseId}/components/count`, false);
}

/**
 * Helper hook for fetching the number of components in a given release group.
 * @param {number} releaseGroupId - The ID of the release group.
 * @param {number} releaseId - The ID of the release.
 * @param {boolean} shouldFetch - Whether to fetch the number of components.
 * @returns A query for the number of components in the given release group.
 */
export default function useGetReleaseGroupComponentCount(
  releaseGroupId: number,
  releaseId: number,
  shouldFetch = true,
) {
  return useQuery<{ count: number }>({
    queryKey: getReleaseGroupComponentCountQueryKey(releaseGroupId, releaseId),
    queryFn: () => getReleaseGroupComponentCount(releaseGroupId, releaseId),
    enabled: shouldFetch,
  });
}
